import { BillingInvoiceDto } from '@shared/core/billing'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'

export const GET_INVOICES_CACHE_KEY = 'get-invoices'

export function useInvoices(_params?: unknown, options?: UseQueryOptions<BillingInvoiceDto[]>) {
  const handleRetry = useHandleRetry()

  return useQuery(GET_INVOICES_CACHE_KEY, () => ApiService.Billing.getInvoices(), {
    staleTime: 300000,
    retry: handleRetry,
    ...options,
  })
}
